import Banner from './Banner';

export { Props } from './Banner';
export default Banner;
